import React from "react"
import MyRadiosWithLabelAndDescriptionFormField from "@common-components/fields/MyRadiosWithLabelAndDescriptionFormField"
import MySelectCreatableFormField from "@common-components/fields/MySelectCreatableFormField"
import { CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT } from "../../../../../../endpoints"

interface Props {
     helpers: any
     currentUser: any
     onTypeChange: (val: string | number) => void
}

export const InterviewConfiguration: React.FC<Props> = ({ helpers, currentUser, onTypeChange }) => {
     return (
          <div className="p-6 rounded-4 mb-8">
               <h4 className="fw-boldest text-gray-800 mb-6 d-flex align-items-center">
                    <span className="badge badge-circle badge-primary me-3">1</span> Configuration
               </h4>

               <div className="row g-5">
                    <div className="col-12">
                         <MyRadiosWithLabelAndDescriptionFormField
                              name="type"
                              formikProps={helpers}
                              label="Type d'entretien"
                              radios={[
                                   {
                                        label: "Entretien candidat",
                                        description: "Premier contact",
                                        faIcon: "user",
                                        iconColor: "primary",
                                        iconWrapperColor: "light-primary",
                                        radioValue: "TYPE_ENTRETIEN_CANDIDAT",
                                   },
                                   {
                                        label: "Entretien de qualification",
                                        description: "Entretien client",
                                        faIcon: "building",
                                        iconColor: "success",
                                        iconWrapperColor: "light-success",
                                        radioValue: "TYPE_ENTRETIEN_CLIENT",
                                   },
                              ]}
                              onChangeCallback={onTypeChange}
                         />
                    </div>

                    <div className="col-12 mt-4">
                         <MyRadiosWithLabelAndDescriptionFormField
                              name="lieu"
                              formikProps={helpers}
                              label="Lieu de la réunion"
                              radios={[
                                   {
                                        label: "Google Meet",
                                        description: "Visio-conférence",
                                        faIcon: "video",
                                        iconColor: "danger",
                                        iconWrapperColor: "light-danger",
                                        radioValue: "LIEU_MEET",
                                   },
                                   {
                                        label: helpers.values.type === "TYPE_ENTRETIEN_CLIENT" ? "Site client" : "Agence / Physique",
                                        description: helpers.values.type === "TYPE_ENTRETIEN_CANDIDAT" && "Rencontre en personne",
                                        faIcon: "map-marker-alt",
                                        iconColor: "info",
                                        iconWrapperColor: "light-info",
                                        radioValue: "LIEU_AGENCE",
                                   },
                              ]}
                         />
                    </div>

                    {helpers.values.lieu === "LIEU_AGENCE" && (
                         <div className="col-12 animate__animated animate__fadeIn">
                              <div className="bg-white p-5 rounded-3 border border-dashed border-info mt-4">
                                   <label className="form-label fw-boldest text-gray-700 fs-7 text-uppercase required">Adresse précise</label>
                                   <MySelectCreatableFormField
                                        formikProps={helpers}
                                        name="adresse"
                                        endpoint={CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT}
                                        method={"GET"}
                                        placeholder="Saisissez l'adresse..."
                                        isMulti={false}
                                        onChangeCallback={val => helpers.setFieldValue("adresse", val)}
                                   />
                                   {currentUser?.agence?.fullAdresse && (
                                        <button
                                             type="button"
                                             className="btn btn-link fw-bold fs-8 p-0 mt-3"
                                             onClick={() => helpers.setFieldValue("adresse", currentUser.agence?.fullAdresse)}
                                        >
                                             <i className="fas fa-map-pin me-2"></i> Utiliser mon agence : {currentUser.agence.fullAdresse}
                                        </button>
                                   )}
                              </div>
                         </div>
                    )}
               </div>
          </div>
     )
}
